import { globalSystemConstants, systemConstants } from "../../constants";
import { updateObject } from "../../shared/utilitiies";

const initialState = {
  isSailorProfile: true,
  spinnerActions: false,
  isMobile:false
};

const systemReducer = (state = initialState, action) => {
  switch (action.type) {
    case systemConstants.TOGGLE_SAILOR_PROFILE:
      return updateObject(state, {
        isSailorProfile: action.data,
      });
    case systemConstants.MOBILE_DETECTION:
      return updateObject(state, {
        isMobile: action.data,
      });
    case globalSystemConstants.SPINNER_ACTIVATE:
      return updateObject(state, {
        spinnerActions: true,
      });

    case globalSystemConstants.SPINNER_DEACTIVATE:
      return updateObject(state, {
        spinnerActions: false
      });
    default:
      return state;
  }
};

export default systemReducer;
